import Vue from "vue"
import Vuex from "vuex"
import createPersistedState from "vuex-persistedstate"
import i18n from "./i18n"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    lafia_user: {
      is_logined: false,
      user_id: "",
      name: "",
      phone: "",
      email: "",
      profile_image: "",
      type: "",
      status: "",
      created: "",
    },

    lafia_admin: {
      is_logined: false,
      name: "",
      type: "",
      user_id: "",
    },

    lang: "ko",

    temp_sns_user: {},
    promotionCode: null,
    isShowinappBrowserWarning: false,
  },

  getters: {
    // 이전 버전과 호환을 위해서...
    lafiaUser_profile_img_path: function (state) {
      return state.lafia_user.profile_image.includes("/") ? state.lafia_user.profile_image : "/upload/user/profile_image/" + state.lafia_user.profile_image
    },

    isKRW: function (state) {
      return state.lang === "ko"
    },
  },

  mutations: {
    /* 회원 로그인 */
    login: (state, payload) => {
      state.lafia_user.is_logined = true
      state.lafia_user.user_id = payload.user_id
      state.lafia_user.name = payload.name
      state.lafia_user.phone = payload.phone
      state.lafia_user.email = payload.email
      state.lafia_user.profile_image = payload.profile_image
      state.lafia_user.type = payload.type
      state.lafia_user.status = payload.status
      state.lafia_user.created = payload.created
    },

    // 회원 로그아웃
    logout: (state) => {
      state.lafia_user.is_logined = false
      state.lafia_user.user_id = ""
      state.lafia_user.name = ""
      state.lafia_user.phone = ""
      state.lafia_user.email = ""
      state.lafia_user.profile_image = ""
      state.lafia_user.type = ""
      state.lafia_user.status = ""
      state.lafia_user.created = ""
    },

    // 사용자 프로필 수정하기
    update_profile_image: (state, payload) => {
      state.lafia_user.profile_image = payload
    },

    // 관리자 로그인
    admin_login: (state, payload) => {
      state.lafia_admin.is_logined = true
      state.lafia_admin.type = payload.type
      state.lafia_admin.name = payload.name
      state.lafia_admin.user_id = payload.user_id
    },

    // 관리자 로그아웃
    admin_logout: (state) => {
      state.lafia_admin.is_logined = false
      state.lafia_admin.type = ""
      state.lafia_admin.name = ""
      state.lafia_admin.user_id = ""
    },

    ADD_TEMP_SNS_USER: (state, payload) => {
      state.temp_sns_user = payload
    },
    DELETE_TEMP_SNS_USER: (state) => {
      state.temp_sns_user = {}
    },

    ADD_PROMOTION_CODE: (state, payload) => {
      state.promotionCode = payload
    },
    DELETE_PROMOTION_CODE: (state) => {
      state.promotionCode = undefined
    },

    SET_INAPPBROWER_STATE: (state, payload) => {
      state.isShowinappBrowserWarning = payload
    },

    SET_LANG(state, payload) {
      const supportLang = ["ko", "en", "jp"]
      state.lang = supportLang.includes(payload) ? payload : "ko"
      i18n.locale = state.lang
    },
  },

  actions: {},

  modules: {},

  plugins: [
    createPersistedState({
      paths: ["lafia_user", "lafia_admin", "lang"],
    }),
    // createPersistedState({
    //   storage: window.sessionStorage,
    //   paths: ["temp_sns_user"],
    // }),
  ],
})
